module.exports = __webpack_public_path__ + "content/dam/oppo/coloros/img/fluent-app-icon-2.802da868.png";